import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", null, "Инструкция настройки интеграции по API ⚙", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h6", { class: "q-my-md" }, "Отправка данных формы (создание лида)", -1)
const _hoisted_3 = { class: "flex items-center q-my-md" }
const _hoisted_4 = { class: "light-text underlined" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Поля запроса (body):")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "light-text" }, "firstname"),
    /*#__PURE__*/_createTextVNode(" - имя клиента, < 100 символов ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "light-text" }, "lastname"),
    /*#__PURE__*/_createTextVNode(" - фамилия клиента, < 100 символов ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "light-text" }, "email"),
    /*#__PURE__*/_createTextVNode(" - почта клиента, < 70 символов ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "light-text" }, "phone"),
    /*#__PURE__*/_createTextVNode(" - телефон клиента, 8 < phone < 26 символов ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "light-text" }, "offer_name"),
    /*#__PURE__*/_createTextVNode(" - имя оффера, на который создан поток (например Bitcoinera). Уточняйте в личного менеджера. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "light-text" }, "campaign_id"),
    /*#__PURE__*/_createTextVNode(" - ID кампании с нашей сети. Береться ID потока, например 509. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "light-text" }, "redirect_url"),
    /*#__PURE__*/_createTextVNode(" - URL, на которую следует перенаправить клиента после приема заказа (опционально). ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "light-text" }, "sub1, sub2, sub3, sub4, sub5"),
    /*#__PURE__*/_createTextVNode(" - саб-айди для передачи дополнительных параметров (опционально)."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" В html форме для сабов можно подставлять динамические значения, например: value={subid} ")
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "row q-mt-lg" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "col-5" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Пример 1. Отправка JSON:")
  ])
], -1)
const _hoisted_8 = { class: "code-block" }
const _hoisted_9 = { class: "row q-mb-md" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("b", null, "POST", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("b", null, "JSON", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "col-5" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Пример 2. Отправка с веб-страницы:")
  ])
], -1)
const _hoisted_14 = { class: "code-block" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, " Для отправки с веб-страницы (лендинга), опишите форму заказа с помощью HTML, чтобы она содержала все необходимые поля. ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h6", null, "Скрипт на PHP", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Для трекинга кликов по Вашему промо необходимо добавить php скрипт "),
  /*#__PURE__*/_createElementVNode("b", null, "вначале"),
  /*#__PURE__*/_createTextVNode(" Вашего index.php файла и указать "),
  /*#__PURE__*/_createElementVNode("b", null, "$campaignId"),
  /*#__PURE__*/_createTextVNode(" (обязательно) и сиды (опционально). "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Пример: "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" $campaignId = 1;"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" $sid1 = 'test';"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Если скрипт не добавлен:"),
  /*#__PURE__*/_createTextVNode(" клики будут засчитываться в статистику только в случае оформления заказа / регистрации. В форме Вам обязательно нужно будет указывать поле "),
  /*#__PURE__*/_createElementVNode("b", null, "campaign_id"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "col-5" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Пример:")
  ])
], -1)
const _hoisted_20 = { class: "code-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "q-mx-xl" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("h6", _hoisted_3, [
        _createTextVNode(" POST Request URL:   "),
        _createElementVNode("a", _hoisted_4, _toDisplayString(_ctx.url), 1),
        _createTextVNode("    "),
        _createVNode(_component_vue_feather, {
          class: "copy-icon",
          size: "18px",
          type: "copy",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copy(_ctx.url)))
        })
      ]),
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          class: "copy-btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copy(_ctx.json)))
        }, [
          _createVNode(_component_vue_feather, { type: "copy" }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('copy')), 1)
        ]),
        _createElementVNode("pre", null, [
          _createElementVNode("code", null, _toDisplayString(_ctx.json), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("p", _hoisted_10, [
          _createTextVNode(" Для создания лида отправте "),
          _hoisted_11,
          _createTextVNode(" запрос с данными в формате "),
          _hoisted_12,
          _createTextVNode(" на "),
          _createElementVNode("b", null, _toDisplayString(_ctx.url), 1),
          _createTextVNode(". ")
        ])
      ]),
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", {
          class: "copy-btn",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.copy(_ctx.form)))
        }, [
          _createVNode(_component_vue_feather, { type: "copy" }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('copy')), 1)
        ]),
        _createElementVNode("pre", null, [
          _createElementVNode("code", null, _toDisplayString(_ctx.form), 1)
        ])
      ]),
      _hoisted_15,
      _hoisted_16,
      _hoisted_17,
      _hoisted_18,
      _hoisted_19,
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", {
          class: "copy-btn",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.copy(_ctx.script)))
        }, [
          _createVNode(_component_vue_feather, { type: "copy" }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('copy')), 1)
        ]),
        _createElementVNode("pre", null, [
          _createElementVNode("code", null, _toDisplayString(_ctx.script), 1)
        ])
      ])
    ]),
    _: 1
  }))
}